module.exports = __webpack_public_path__ + "static/img/part1.7c2c93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/part1.png
// module id = 6CBl
// module chunks = 9